import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyEn5() {
  return (
    <div>
      <Heading
        type="h3"
        title={
          <>
            {`V.`}
            <br />
            {`Duration of the Agreement`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`The Agreement is concluded for an indefinite period, unless expressly agreed otherwise.`}</li>
            <li>{`Either Contracting Party may terminate the Agreement, even without giving a reason. The notice period is 1 month, and starts from the first day of the month following the month in which the notice was delivered and ends on the last day of such month.`}</li>
            <li>{`The termination can also be made by the User by e-mail from the current e-mail address specified in the User's User account, or within the User's User account.`}</li>
            <li>{`Termination by the User is also considered if the User does not pay within 10 days from the end of the last currently paid subscription period the price (or part thereof) for the service for the next period. In this case, the Agreement expires on the last day of this 10-day period.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={5} className={sList}>
            <li>{`In accordance with the provisions of Section 1829 (1) of the Civil Code, the User who is a consumer has the right to withdraw from the Agreement within 14 days of its conclusion. Withdrawal from the Agreement must be sent to the Provider within the period specified in the previous sentence.`}</li>
            <li>{`To withdraw from the Agreement, the User can use the sample form provided by the Provider, which is attached to these terms and conditions.`}</li>
            <li>{`By sending the order, the User agrees that the Provider can start providing the service immediately after delivery of the order, even before the expiration of the statutory period for withdrawal from the Agreement. By providing the service (i.e. digital content), the User loses the right to withdraw from the Agreement within the first 14 days of its conclusion.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyEn5;
